import { ErrorNote, Loading, Screen } from '../components/primitives';
import { GoalsPanel } from '../components/panels/goals';
import { useActiveGoals } from '../lib/queries';

/** SC-33. */
export function GoalsPage() {
  const goals = useActiveGoals();

  if (goals.isPending) return <Loading />;
  if (goals.isError) return <ErrorNote error={goals.error} retry={() => void goals.refetch()} />;

  return (
    <Screen back="/achieve" eyebrow="Achieve" title="My goals">
      <GoalsPanel goals={goals.data} variant="page" />
    </Screen>
  );
}
